import { render } from "./PrivacyView.vue?vue&type=template&id=14d3ae75&scoped=true"
const script = {}

import "./PrivacyView.vue?vue&type=style&index=0&id=14d3ae75&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14d3ae75"]])

export default __exports__